/*
 * @Author: yuanjianlong
 * @Description:
 * @Date: 2021-07-26 16:27:34
 * @LastEditTime: 2024-09-05 14:19:37
 * @FilePath: /teacher-h5/src/main.js
 */
import Vue from 'vue'
import router from '@/router/index'
import store from '@/store'
import App from './App.vue'
import moment from 'moment'
import Antd, { message } from 'ant-design-vue'
import service from './service'
import storage from '@/utils/storage.js'
import cookie from '@/utils/cookies.js'
import utils from '@/utils/index.js'
import { TimeLoop } from '@/utils/prisonClass.js'
import filters from './filters/index'
import Loading from './components/Loading'
import Lottie from './components/Lottie'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import { initUploader } from '@/utils/upload'
import Directives from './directives'

import VueCompositionAPI from '@vue/composition-api'

import SvgIcon from '@/components/SvgIcon.vue'

// 缓存批改图片
import fabric from 'fabric'
import { ResultSealCache } from '@/components/Correct/brushConf.js'

Vue.component('SvgIcon', SvgIcon)

Vue.use(VueCompositionAPI)
Vue.use(Directives)

Sentry.init({
  dsn: 'https://2e8529e8940e4dd58d2f392c7d0da292@sentry.aixuexi.com/115',
  release: window.SentryReleaseId,
  integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
  environment: process.env.NODE_ENV
})

// 开发时引入mock数据
if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true
  // require('./mock/mock.js')
}

rewriteSendAmcLog()
rewriteSendLogById()
moment.locale('zh-cn')

Vue.use(Antd)
message.config({
  top: `64px`,
  maxCount: 1
})

Vue.prototype.$userList = []
Vue.prototype.$service = service
Vue.prototype.$storage = storage
Vue.prototype.$message = message
Vue.prototype.$cookie = cookie
Vue.prototype.$moment = moment
Vue.prototype.$utils = utils
Vue.prototype.$timeLoop = new TimeLoop()
Vue.prototype.$resultSealCache = new ResultSealCache(fabric)

// 初始化存储
Vue.prototype.$axxUpload = initUploader(service.correction.getUploadToken)
// 重写 Logger，精准学的埋点，弃用
function Logger() {}
const logger = Logger
Vue.prototype.$logger = logger
Vue.use(Loading)
Vue.use(Lottie)

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

/**
 * 重写sendAmcLog 方法
 * 精准学的埋点，弃用
 */
function rewriteSendAmcLog() {
  Logger.prototype.sendAmcLogCopy = () => {}
  Logger.prototype.sendAmcLog = () => {}
}

/**
 * 重写sendLogById 方法
 * 精准学的埋点，弃用
 */
function rewriteSendLogById() {
  Logger.prototype.sendLogByIdCopy = () => {}
  Logger.prototype.sendLogById = () => {}
}

const vueObj = new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
export default vueObj
